import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import {listProductDocument} from '../../../../../helpers/constant';
import {ProductsDocumentsService} from '../../../../../services';

@Component({
  selector: 'app-product-document-assign',
  templateUrl: './product-document-assign.component.html',
  styleUrls: ['./product-document-assign.component.scss']
})
export class ProductDocumentAssignComponent implements OnInit {

  constructor(private  fb: FormBuilder,
              private productsDocumentsService: ProductsDocumentsService,) { }

  current: number = 1;
  isVisible = false;
  check: string = 'product';
  str: string = 'isShow';
  @Input() str2: string;
  isSuperAdmin = false;
  documentProduct: any = listProductDocument;
  form = this.fb.group({
    docProductType: [null, [Validators.required]],
  });

  radioValue = 'only';
  options = [
    { label: 'Áp dụng cho toàn bộ sản phẩm khác', value: 'all' },
    { label: 'Chọn sản phẩm cùng áp dụng', value: 'more' },
    { label: 'Áp dụng cho sản phẩm hiện tại', value: 'only' },
  ];

  documentId: any = [];
  productId: any = [];
  isRequired: Boolean = false;

  @Output() assignProduct = new EventEmitter<any>();
  // tslint:disable-next-line:ban-types
  isLoadingBtn: Boolean = false;

  ngOnInit() {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser) {
      this.isSuperAdmin = currentUser.isAdmin;
    }
  }

  documentType: any;
  showModal(type?) {
    this.radioValue = 'only';
    this.current = 1;
    this.isVisible = true;
    this.form.reset();
    this.documentType = type;
    this.log(this.radioValue);

    const params = {
      page: 1,
      pageSize: 200,
      isDocument: true
    } as any;
    if (this.documentType) {
      // tslint:disable-next-line:no-unused-expression
      params.type = this.documentType;
    }
    this.productsDocumentsService.listDocumentType(params).subscribe(res => {
      this.documentProduct = res.data;
    });
  }

  handleCancel() {
    this.isVisible = false;
  }

  log(data: any) {
    if (data === 'only') {
      const path_url = window.location.href.split('/');
      this.productId = [path_url[5]];
      return;
    }
  }
  listProducts(data: any) {
    this.productId = data;
    if (data.length > 0) {
      this.isRequired = false;
    } else {
      this.isRequired = true;
    }
  }

  selectDocuments(data: any) {
    if (data === 'isShowProduct') {
      this.handleCancel();
      return;
    }
    this.documentId = data.ids;
    this.current = data.current;
  }
  onSubmit() {
    if (!this.isSuperAdmin || !this.documentType) {
      this.form.get('docProductType').clearValidators();
      this.form.get('docProductType').updateValueAndValidity();
    }
    // tslint:disable-next-line:forin
    for (const i in this.form.controls) {
      this.form.controls[i].markAsDirty();
      this.form.controls[i].updateValueAndValidity();
    }
    if (!this.form.valid) {return; }
    if (this.radioValue === 'all') {
      this.isRequired = false;
      const body: any = {
        listDocumentId: this.documentId,
        assignAll: true,
        docProductType: this.form.get('docProductType').value
      };
      this.assignProduct.emit(body);
      this.isVisible = false;
      return;
    } else {
      this.isRequired = false;
      if (!this.productId.length) {
        this.isRequired = true;
        return;
      }
      const body: any = {
        listDocumentId: this.documentId,
        listProductId: this.productId,
        assignAll: false,
        docProductType: this.form.get('docProductType').value
      };
      this.isLoadingBtn = true;
      this.assignProduct.emit(body);
      this.isVisible = false;
      return;
    }
  }

  success() {
    this.isLoadingBtn = false;
  }

}
